export default {
  methods: {
    triggerLastStep() {
      if(this.triggersShouldFire())
        this.tryFireAndForgetTrigger(`LastStepTrigger`)
    },
    triggerClickedOfferRequest() {
      if(this.triggersShouldFire())
        this.tryFireAndForgetTrigger(`OrderRequestTrigger`)
    },
    triggerClickedSignUp() {
      if(this.triggersShouldFire())
        this.tryFireAndForgetTrigger(`SignUpClickedTrigger`)
    },
    triggerClickedDownloadDataSheet() {
      if(this.triggersShouldFire())
        this.tryFireAndForgetTrigger(`DownloadDatasheetClickedTrigger`)
    },
    triggerClickedAddToCart() {
      if(this.triggersShouldFire())
        this.tryFireAndForgetTrigger(`AddToCartClickedTrigger`)
    },
    buildPaylod() {
      return {
        user: this.$store.state.loggedIn 
          ? this.$store.state.userData
          : `anonymous`,
        referrer: document.referrer,
        ip: `see telemetry`,
        configuration: {
          type: this.$route.name,
          summary: this.summary,
          length: this.$store.state.cableLength
        }
      }
    },
    triggersShouldFire () {
      return (
        process.env.NODE_ENV === `production` 
        && ( window.location.hostname === `pulse.sachsenkabel.de`
          || window.location.hostname === `sachsenkabel.evalmate.ito-consult.de`)
        && this.$store.state.userData.id !== 1
      )
    },
    tryFireAndForgetTrigger (triggerName = 'SomeTrigger') {
      try {
        let payload = this.buildPaylod()
        this.$rollbar.info(`[${triggerName}]`, payload)
      } catch (err) {
        // fire and forget
        // eslint-disable-next-line
      }
    }
  }
}